import { useContext } from 'react';
import { RootStore } from '@src/Store/Store';
import { StoreContext } from '@src/Store/Store.context';
export const useStores = (): RootStore => useContext(StoreContext);
